import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateTime } from 'luxon';

import { BaseListDomainService } from '@common/domain/base-list-domain.service';
import { DatesService } from '@common/services/dates.service';
import { ResultApi } from '@common/api/result-api';
import { StatusPerDay, Status } from '../../models';
import { VboRatesApi } from '@apps/bckp/api/models/vbo-rates-api';
import { VboSuccessRateListApiService } from '@apps/bckp/api/veeam/vbo/vbo-successrate-list-api.service';

@Injectable({
    providedIn: 'root'
})
export class VboSuccessRateListDomainService extends BaseListDomainService
{
    constructor (
        private vboSuccessRateListApiService: VboSuccessRateListApiService,
        private datesService: DatesService
    )
    {
        super();
    }

    getStatusPerRange (since: DateTime, until: DateTime): Observable<StatusPerDay[]>
    {
        return this.getSuccessRates(since, until);
    }

    getLastSession (since: DateTime, until: DateTime): Observable<Status[]>
    {
        const init: Status[] = [0, 1, 2].map((idx: number) => new Status(idx, 0, idx));

        return this.getSuccessRates(since, until)
            .pipe(
                map((successRates: StatusPerDay[]) =>
                    successRates.reduce((prev: Status[], curr: StatusPerDay) =>
                    {
                        for (let idx = 0; idx < 3; idx++)
                        {
                            prev[idx].counter += curr.groupByCodeStatuses[idx].counter;
                        }

                        return prev;

                    }, init))
            );
    }

    getSuccessRates (since: DateTime, until: DateTime): Observable<StatusPerDay[]>
    {
        const range: string = this.datesService.RawUtcDateRange(since, until);

        return this.vboSuccessRateListApiService.getDailyRates(range)
            .pipe(
                map((obj: ResultApi<VboRatesApi>): VboRatesApi[] =>
                    obj.value
                ),
                map((result: VboRatesApi[]) =>
                    result.map<StatusPerDay>(vbo => StatusPerDay.mapperFromVboRates(vbo))
                )
            );
    }

    getTotalCapacity (since: DateTime, until: DateTime): Observable<number>
    {
        const range: string = this.datesService.RawUtcDateRange(since, until);

        return this.vboSuccessRateListApiService.getDailyRates(range)
            .pipe(
                map((obj: any): VboRatesApi[] =>
                    obj.value
                ),
                map((result: VboRatesApi[]) =>
                    result.reduce((prev: number, curr: VboRatesApi) =>
                        prev + curr.totalTransferredSize, 0)
                )
            );
    }
}
